import { RelatedProductsService } from '@df/catalog-ui/related-products/related-products.service';
import { KlevuSearch } from '@df/module-klevu-search/klevu-interfaces';
import { NICmsContentField } from '@icms/core/content';
import { IPageComponentProductCarouselSection } from './product-carousel.interface';
import { klevuRecomendationsFileds } from './klevu-recommendations.config';
import { AdvancedCommerce } from '@df/module-advanced-commerce';

export const PRODUCT_CAROSUEL_CONFIG = {
    id: 'product-carousel',
    name: 'Product Carousel',
    tags: ['category, discipline, carousel'],
    fields: [
        // header
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title of the carousel',
            required: true,
            default: 'Goes Perfectly With'
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'subtitle',
            title: 'Subtitle'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            title: 'Sections',
            key: 'sections',
            description: 'Only carousels with products inside will be visible',
            itemName: 'section',
            itemNameField: 'title',
            complex: true,
            fields: [
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.label,
                    key: '_section-content',
                    title: 'Content'
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'title',
                    title: 'Title of the section',
                    required: true,
                    default: 'Title of the section'
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'view_all_copy',
                    title: '"View All" text',
                    canShow: (data: IPageComponentProductCarouselSection) => data?.engine !== 'recent'
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'view_all_href',
                    title: '"View All" link',
                    canShow: (data: IPageComponentProductCarouselSection) => data?.engine !== 'recent'
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.label,
                    key: '_section-engine',
                    title: 'Engine'
                },
                <NICmsContentField.IChoiceField>{
                    key: 'engine',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Engine',
                    required: true,
                    default: 'category',
                    options: () =>
                        Object.keys(RelatedProductsService.engines)
                            .filter(e => e !== AdvancedCommerce.Engine.Id.recommendations)
                            .map(i => ({ key: i, title: i }))
                },
                ...klevuRecomendationsFileds(),
                <NICmsContentField.IRelationField>{
                    key: 'category_ids',
                    type: NICmsContentField.EFieldType.relation,
                    title: 'Category',
                    options: {
                        title: 'Category',
                        type: 'category',
                        multiple: true
                    },
                    canShow: (data: IPageComponentProductCarouselSection) => data?.engine === 'category'
                },
                <NICmsContentField.IRelationField>{
                    key: 'product_ids',
                    type: NICmsContentField.EFieldType.relation,
                    title: 'Items',
                    options: {
                        title: 'Product',
                        type: 'product',
                        multiple: true
                    },
                    canShow: (data: IPageComponentProductCarouselSection) => data?.engine === 'manual'
                },
                <NICmsContentField.INumberField>{
                    key: 'limit',
                    type: NICmsContentField.EFieldType.number,
                    title: 'Items Limit',
                    description: 'Max number of items that can be displayed',
                    default: 36,
                    min: 1,
                    max: 36,
                    required: true
                }
            ],
            default: [
                {
                    title: 'Get the look',
                    engine: 'manual',
                    limit: 36,
                    product_ids: [-1000, -1001, -1002]
                },
                {
                    title: 'Recently Viewed',
                    engine: 'recent',
                    limit: 12
                }
            ],
            defaultSize: 2,
            maxSize: 2
        }
    ]
};
